// app/javascript/controllers/clickable_row_controller.js
import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.click.bind(this));
  }

  click(event) {
    const target = event.target;
    if (target.closest("a, button")) {
      // If it is, allow the default action (e.g., following the link)
      // console.log("target.closest('a, button'): ", target.closest("a, button")); 
      //In case we want to have other clickable elements in the row
      return;
    } else {
      // console.log("elsing........................................");
    }
    
    const url = this.element.dataset.url;
    if (url) {
      window.location = url;
    }
  }
}
